var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{style:({
      height: _vm.iconSize + 'px',
      width: _vm.iconSize + 'px',
      backgroundImage: ("url(" + (require(("@/assets/icons/" + _vm.icon + ".svg"))) + ")"),
      backgroundRepeat: 'no-repeat',
      backgroundPosition: 'center',
      backgroundSize: '100%'
    })}),_c('a',{style:({
      color: _vm.color,
      fontSize: _vm.fontSize + 'px',
      margin: _vm.margin
    })},[_vm._v(_vm._s(_vm.title))])])}
var staticRenderFns = []

export { render, staticRenderFns }